export default __webpack_public_path__ + "static/data-vis-text-charts-do-5d909cfc4d54280bd174e7504801175c123dd429919b965e7ead0bc06c553a18.png";